<template>
  <main-layout :selectedMenu="'myHome'">
    <div class="container">
        <asideCom :activityIndex="2"></asideCom>
        <div class="jobWanted">
            <p class="title">求职管理<span>有任何疑问可联系MANA小助手，微信号：manamananet</span></p>
            <div class="typeBox clearfix">
                <span :class="[type==1?'active':'']" @click="type=1">投递记录</span><span :class="[type==2?'active':'']" @click="type=2">收藏职位</span>
                <div class="myResume" @click="gotoMyResume">我的简历/作品集<i v-if="isOk">待完善</i></div>
            </div>
            <div class="listBox" v-if="type==1">
                <div class="boxList" v-if="sendList.length">
                    <div :class="[item.recruitStatus == 4 ? 'li li1 clearfix' : 'li clearfix']" v-for="(item,i) in sendList" :key="i" @click.stop.prevent="gotoRecruit(item)">
                        <div class="leftBox">
                            <p class="name"><span :class="[item.recruitStatus == 4 ? 'positionName positionName1' : 'positionName']">{{item.positionName}}</span><i v-if="item.recruitStatus == 4">职位已下线</i></p>
                            <p class="price"><span :class="[item.recruitStatus == 4 ? 'active': '']">{{item.negotiable == 1 ? '面议' : item.salaryBegin + 'K' + '-' + item.salaryEnd + 'K'}}</span>/ {{item.cityName}} / 经验{{getExperience(item.experience)}} / {{getEducation(item.education)}}</p>
                        </div>
                        <div :class="[item.recruitStatus == 4 ? 'infoBox infoBox1' : 'infoBox']" @click.stop.prevent="gotoPeople(item.userId)">
                            <img :src="item.avatar | imageUrl('/static/profile_img_default.png',36,36)" alt="">{{item.nickName}}
                        </div>
                        <div :class="[item.recruitStatus == 4 ? 'status2' : item.status == 1 ? 'status': item.status == 2 ? 'status1' : 'status2']">{{getStatus(item.status)}}</div>
                    </div>
                </div>
                <Loading v-if="loading1" />
                <Reload v-if="loadError1" @callback="loadMore" />
                <no-more v-if="!hasNextPage1 && sendList.length" />
                <div class="noData" v-if="!sendList.length">
                    <img src="https://image.manamana.net/1657784618000_sgFKRNGo" alt="">
                    <p>暂无数据</p>
                </div>
            </div>
            <div class="listBox" v-if="type==2">
                <div class="boxList" v-if="collectList.length">
                    <div :class="[item.recruitStatus == 4 ? 'li li1 clearfix' : 'li clearfix']" v-for="(item,i) in collectList" :key="i" @click.stop.prevent="gotoRecruit(item)">
                        <div class="leftBox">
                            <p class="name"><span :class="[item.recruitStatus == 4 ? 'positionName positionName1' : 'positionName']">{{item.positionName}}</span><span class="time">{{item.auditTime | dateToNow(language)}} {{$t('recruit.发布')}}</span><i v-if="item.recruitStatus == 4">职位已下线</i></p>
                            <p class="price"><span :class="[item.recruitStatus == 4 ? 'active': '']">{{item.negotiable == 1 ? '面议' : item.salaryBegin + 'K' + '-' + item.salaryEnd + 'K'}}</span>/ {{item.cityName}} / 经验{{getExperience(item.experience)}} / {{getEducation(item.education)}}</p>
                        </div>
                        <div :class="[item.recruitStatus == 4 ? 'infoBox infoBox1' : 'infoBox']" @click.stop.prevent="gotoPeople(item.userId)">
                            <img :src="item.avatar | imageUrl('/static/profile_img_default.png',36,36)" alt="">{{item.nickName}}
                        </div>
                        <div class="status3" @click.stop.prevent="collectRecruit(item.recruitId)">取消收藏</div>
                    </div>
                </div>
                <Loading v-if="loading2" />
                <Reload v-if="loadError2" @callback="loadMore" />
                <no-more v-if="!hasNextPage2 && collectList.length" />
                <div class="noData" v-if="!collectList.length">
                    <img src="https://image.manamana.net/1657784618000_sgFKRNGo" alt="">
                    <p>暂无数据</p>
                </div>
            </div>
        </div>
        </div>
  </main-layout>
</template>

<script type="text/ecmascript-6">
import MainLayout from "@/layouts/MainLayout";
import asideCom from "@/components/aside.vue";
import Reload from "@/components/v2/match/reload";
import Loading from "@/components/v2/match/loading";
import NoMore from "@/components/v2/NoMore";
import {
  getScrollHeight,
  getScrollTop,
  getWindowHeight
} from "@/assets/screen";
export default {
  name: "jobWanted",
  metaInfo() {
    return {
      title: "求职管理 | MANA"
    };
  },
  data() {
    return {
      type: 1,
      sendList: [],
      collectList: [],
      pageIndex1: 1,
      pageIndex2: 1,
      hasNextPage1: false,
      hasNextPage2: false,
      loadError1: false,
      loadError2: false,
      loading1: false,
      loading2: false,
      isOk: true
    };
  },
  components: {
    MainLayout,
    asideCom,
    Reload,
    Loading,
    NoMore
  },
  created() {
    this.getResumeCheck();
    this.getSendResume();
    this.getCollectList();
  },
  computed: {
    language() {
      return this.$language();
    }
  },
  mounted() {
    window.addEventListener("scroll", this.loadMore);
  },
  destroyed() {
    window.removeEventListener("scroll", this.loadMore, false);
  },
  methods: {
    getResumeCheck() {
      this.$http
        .get("/api/u/recruit/resume/online/info/resume/check")
        .then(res => {
          if (res.code == "OK") {
            if (res.data.isOk == 1) {
              //简历已完善
              this.isOk = false;
            } else {
              //简历未完善
              this.isOk = true;
            }
          }
        });
    },
    loadMore() {
      if (getScrollTop() + getWindowHeight() >= getScrollHeight() - 120) {
        if (this.type == 1) {
          if (!this.loading1 && this.hasNextPage1) {
            this.getSendResume();
          }
        }
        if (this.type == 2) {
          if (!this.loading2 && this.hasNextPage2) {
            this.getCollectList();
          }
        }
      }
    },
    collectRecruit(id) {
      this.$http.get("/api/u/recruit/collect/cancel/" + id).then(res => {
        if (res.code == "OK") {
          this.$message.success(res.message);
          this.pageIndex2 = 1;
          this.getCollectList();
        }
      });
    },
    gotoRecruit(item) {
      if (item.recruitStatus == 3) {
        let routeData = this.$router.resolve({
          path: "/recruitDetail/" + item.recruitId
        });
        window.open(routeData.href, "_blank");
      }
    },
    gotoPeople(id) {
      let routeData = this.$router.resolve({
        path: "/peopleCenter/" + id + "/home"
      });
      window.open(routeData.href, "_blank");
    },
    getStatus(i) {
      if (i == 1) {
        return "待处理";
      }
      if (i == 2) {
        return "已约面";
      }
      if (i == 3) {
        return "已拒绝";
      }
    },
    getEducation(i) {
      if (i == 1) {
        return this.$t("recruit.不限");
      }
      if (i == 2) {
        return this.$t("recruit.大专");
      }
      if (i == 3) {
        return this.$t("recruit.本科");
      }
      if (i == 4) {
        return this.$t("recruit.硕士");
      }
      if (i == 5) {
        return this.$t("recruit.博士");
      }
    },
    getExperience(i) {
      if (i == 1) {
        return this.$t("recruit.不限");
      }
      if (i == 2) {
        return this.$t("recruit.1年以下");
      }
      if (i == 3) {
        return this.$t("recruit.1-3年");
      }
      if (i == 4) {
        return this.$t("recruit.3-5年");
      }
      if (i == 5) {
        return this.$t("recruit.5-10年");
      }
      if (i == 6) {
        return this.$t("recruit.10年以上");
      }
    },
    getSendResume() {
      this.loading1 = true;
      this.$http
        .get(
          "/api/u/recruit/manage/send/resume" +
            "?pageSize=10" +
            "&pageIndex=" +
            this.pageIndex1
        )
        .then(res => {
          if (res.code == "OK") {
            if (this.pageIndex1 === 1) {
              this.sendList = [];
            }
            this.hasNextPage1 = res.data.hasNextPage;
            this.sendList = [...this.sendList, ...res.data.list];
            this.loading1 = false;
            this.loadError1 = false;
            this.pageIndex1++;
          } else {
            this.loadError1 = true;
            if (this.pageIndex1 !== 1) {
              this.pageIndex1--;
            }
          }
        });
    },
    getCollectList() {
      this.loading2 = true;
      this.$http
        .get(
          "/api/u/recruit/collect/list" +
            "?pageSize=10" +
            "&pageIndex=" +
            this.pageIndex2
        )
        .then(res => {
          if (res.code == "OK") {
            if (this.pageIndex2 === 1) {
              this.collectList = [];
            }
            this.hasNextPage2 = res.data.hasNextPage;
            this.collectList = [...this.collectList, ...res.data.list];
            this.loading2 = false;
            this.loadError2 = false;
            this.pageIndex2++;
          } else {
            this.loadError2 = true;
            if (this.pageIndex2 !== 1) {
              this.pageIndex2--;
            }
          }
        });
    },
    gotoMyResume() {
      this.$router.push("/MyResume");
    }
  },
  watch: {}
};
</script>
<style lang="stylus" rel="stylesheet/stylus" scoped>
.body {
  background: #FAFAFA;
}
.container{
  width: 1110px;
  padding: 40px 0 120px 0;
  display: flex;
  margin: 0 auto;
  background: #FAFAFA;
  .jobWanted{
    width: 825px;
    padding-top: 16px;
    min-height: 100vh;
    .title{
        font-size: 24px;
        font-weight: 600;
        color: #333333;
        line-height: 36px;
        span{
            font-size: 12px;
            font-weight: 400;
            color: #999999;
            margin-left: 20px;
        }
    }
    .typeBox{
        height: 36px;
        line-height: 36px;
        border-bottom: 1px solid #EBEBEB;
        position: relative;
        padding-top: 12px;
        span{
            height: 36px;
            font-size: 16px;
            font-weight: 400;
            color: #999999;
            line-height: 36px;
            display: inline-block;
            margin-right: 37px;
            cursor: pointer;
        }
        span.active{
            font-weight: 600;
            color: #333333;
            border-bottom: 2px solid #333;
        }
        .myResume{
            float: right;
            position: relative;
            font-size: 16px;
            font-weight: 600;
            color: #2026CC;
            cursor: pointer;
            i{ 
                padding: 0 5px;
                height: 16px;
                line-height: 16px;
                background: #FE5630;
                border-radius: 3px;
                font-size: 10px;
                font-weight: 400;
                color: #FFFFFF;
                float: right;
                margin-left: -6px;
            }
        }
    }
    .listBox{
        .boxList{
            padding-bottom: 40px;
        }
        margin-top: 20px;
        .li{
            width: 825px;
            height: 98px;
            background: #FFFFFF;
            margin-bottom: 10px;
            padding: 20px;
            box-sizing: border-box;
            cursor: pointer;
            .leftBox{
                float: left;
                width: 420px;
                .name{
                    height: 24px;
                    line-height: 24px;
                    margin-bottom: 10px;
                    .positionName{
                        font-size: 16px;
                        font-weight: 600;
                        color: #333333;
                        display: inline-block;
                        max-width: 220px;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                        vertical-align: middle;
                    }
                    .positionName1{
                        color: #999;
                    }
                    .time{
                        font-size: 12px;
                        font-weight: 400;
                        color: #999999;
                        margin-left: 10px;
                    }
                    i{
                        display: inline-block;
                        padding: 0 8px;
                        height: 26px;
                        line-height: 26px;
                        background: rgba(26,26,26,0.06);
                        border-radius: 3px;
                        font-size: 12px;
                        font-weight: 400;
                        margin-left: 10px;
                        color: #666666;
                    }
                }
                .price{
                    height: 24px;
                    font-size: 14px;
                    font-weight: 400;
                    color: #999999;
                    line-height: 24px;
                    span{
                        color: #FC703E;
                        margin-right: 10px;
                    }
                    span.active{
                        color: #999;
                    }
                }
            }
            .infoBox{
                float: left;
                margin-top: 10px;
                height: 36px;
                font-size: 14px;
                font-weight: 600;
                color: #333333;
                line-height: 36px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                width: 250px;
                cursor: pointer;
                img{
                    width: 36px;
                    height: 36px;
                    border-radius: 50%;
                    margin-right: 10px;
                }
            }
            .infoBox1{
                color: #999;
            }
            .status{
                float: right;
                height: 22px;
                font-size: 14px;
                font-weight: 400;
                color: #F55F54;
                line-height: 22px;
                margin-top: 12px;
            }
            .status1{
                float: right;
                height: 22px;
                font-size: 14px;
                font-weight: 400;
                color: #0EA93E;
                line-height: 22px;
                margin-top: 12px;
            }
            .status2{
                float: right;
                height: 22px;
                font-size: 14px;
                font-weight: 400;
                color: #999999;
                line-height: 22px;
                margin-top: 12px;
            }
            .status3{
                float: right;
                height: 22px;
                font-size: 14px;
                font-weight: 400;
                color: #2026CC;
                line-height: 22px;
                margin-top: 12px;
            }
        }
        .li1{
          cursor: initial;
        }
        .noData{
            padding-top: 90px;
            text-align: center;
            img{
                width: 284px;
                height: 276px;
                margin: 0 auto;
            }
            p{
                height: 22px;
                margin-top: 40px;
                font-size: 16px;
                font-weight: 400;
                color: #354052;
                line-height: 22px;
            }
        }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/my/account/jobWanted.vue